import { render, staticRenderFns } from "./CommunityHappinessIntroduce.vue?vue&type=template&id=7705ef03&scoped=true&"
import script from "./CommunityHappinessIntroduce.vue?vue&type=script&lang=js&"
export * from "./CommunityHappinessIntroduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7705ef03",
  null
  
)

export default component.exports